import "./index.css";

import React from "react";

const Loader = () => {
    return (
        <div className="loader__wrapper">
            <div className="loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default Loader;